
// ** 기본호출 **
// layer.openFn({ 'target' : '클래스명' });
// ** ajax 호출 **
// layer.openFn({ 'ajaxUrl' : 'url주소' });
// ** 닫기 **
// layer.closeFn( Call Back Function);

document.addEventListener('DOMContentLoaded' , () =>{
    const layer = (function(){
        const defaultOption = {
            target : '.layer',
            $target : document.querySelector('.layer'),
            ajaxUrl : undefined,
            ajaxCall : false,
            prevTarget : undefined,
            active : false
        }
        const bodyEl = document.querySelector('body');
        let option = {};
    
        const openFn = (newOption) => {
            if(option.prevTarget != undefined){
                closeFn( function(){
                    _openFn(newOption);
                });
            }else{
                _openFn(newOption);
            }
    
        }
    
        const closeFn = (callBackFn = undefined) => {
            if(option.active){
                if( option.prevTarget == undefined ){
                    option.prevTarget = option.$target;
                }
                
                if( option.ajaxCall ){
                    option.prevTarget.parentNode.remove();
                    option.ajaxUrl = undefined;
                    option.ajaxCall = false;
                }else{
                    if(option.$target.classList.contains('js-add-prd-layer')){
                        //주문 - 상품 선택 레이어
                        let _layerWidth = document.documentElement.clientWidth;

                        if (_layerWidth < 767) {
                            option.$target.classList.remove('active');

                            setTimeout(function(){
                                option.$target.style.display = 'none';
                            }, 400);
                        } else if (_layerWidth >= 767) {
                            option.$target.style.display = 'none';
                            option.$target.classList.remove('active');
                        }
                    }else if(option.$target.classList.contains('js-prd-detail-layer')){
                        option.$target.classList.remove('active');

                        const top = bodyEl.style.top;
                        bodyEl.style.position = '';
                        bodyEl.style.top = '';
                        bodyEl.style.overflowY = 'visible';
                        window.scrollTo(0, parseInt(top || '0') * -1);
                    }else{
                        option.$target.style.display = 'none';
                        option.$target.classList.remove('active');
                    }
                }
                
                if(document.querySelector("#buyProcess") && 768 <= window.innerWidth){
                    document.querySelector('#buyProcess').classList.remove('pc-active');
                }
    
                bodyEl.classList.remove('ovf');
                option.prevTarget = undefined;
                option.active = false;
                option = defaultOption;
    
                if( callBackFn !== undefined ){
                    callBackFn();
                }
            }
        }

        const bgCloseFn = (currentLayer) => {
            document.querySelector("body").addEventListener("click", function(e) {
                let targetLayer = '';
                if(e.target.className == "layer__table-cell" || e.target.className == "layer__table"){
                    targetLayer = e.target.closest('.layer').className;
                }

                if(e.target.className == currentLayer.className || targetLayer  == currentLayer.className) {
                    closeFn();
                } else {
                }
            })
        }
        const ajaxCheck = () => {
            if( option.ajaxUrl != undefined ){
                fetch(option.ajaxUrl)
                    .then( response => {
                        // console.log(response);
                        if (response.ok) {
                            return response.text();
                        } else {
                            alert('네트워크 오류');
                        }
                    })
                    .then( html => {
                        let dom = document.createElement('div');
                        dom.innerHTML = html;
                        option.$target = dom.querySelector('.layer');

                        document.querySelector('.content').appendChild(dom);
                        
                        _showFn();
                        
                        option.ajaxCall = true;
                    })
                    .catch(function (err) {
                        alert(err)
                    });
            }else{
                _showFn();
            }
        }
    
        const _openFn = (newOption) => {
            option = Object.assign(defaultOption, newOption);
            option.$target = document.querySelector(option.target);
            
            ajaxCheck();
        }

        const _showFn = () => {
            if(option.$target.classList.contains('js-prd-detail-layer')){
                const scrollY = window.scrollY;
                bodyEl.style.position = 'fixed';
                bodyEl.style.top = `-${scrollY}px`;
                bodyEl.style.width = '100%';
                bodyEl.style.overflowY = 'scroll';
            }else{
                option.$target.style.display = 'block';
                
                bodyEl.classList.add('ovf');
            }

            setTimeout(function(){
                option.$target.classList.add('active');
            }, 15);

    
            option.prevTarget = option.$target;
            option.active = true;
    
            let closeBtn = option.$target.querySelectorAll('.close');
    
            closeBtn.forEach(function(el){
                el.addEventListener('click' , function(){
                    closeFn();
                });
            });

            bgCloseFn(option.$target);
        }
    
        const applyFn = () => {
            option = defaultOption;
    
            document.querySelectorAll('.layer_btn').forEach(el => {
                el.addEventListener('click' , function(){
                    const layerName = el.getAttribute('data-layer');
                    if(document.querySelector('.'+layerName)){
                        _openFn({ 'target' : '.'+layerName });

                        if(document.querySelector('.js-photo-layer')){
                            $('.photo-slide__list').slick('setPosition');                    
                        }

                        if(document.querySelector('.js-date-layer')){

                            const $datepicker = $(".js-date-layer .layer__con-area .datepicker");

                            if (!$datepicker.hasClass("hasDatepicker")) {
                                initDatepicker($datepicker);
                            }                            
                        }
                    }else{
                        alert('호출에 문제가 생겼습니다. [ 해당 레이어 없음 ]');
                    }
                });
            });
        }
    
        return {
            applyFn : applyFn,
            openFn : openFn,
            closeFn : closeFn,
        }
    })();

    window.layer = layer;
    window.layer.applyFn();
});
